import * as actionTypes from './actionTypes';
import { DashboardAction, DashboardState } from '../type';
import { combineReducers } from 'redux';
import quotesReducer, { QuoteReducerState } from './Quotes/reducer';
import todosReducer, { TodosReducerState } from './Todos/reducer';
import bookingsReducer, { BookingsReducerState } from './Bookings/reducer';
import vehiclesReducer, { VehiclesReducerState } from './Vehicles/reducer';
import productsReducer, { ProductReducerState } from './Products/reducer';

const initialState: DashboardState = {
  selectedBranch: null,
  alert: {
    title: '',
    type: null,
    subTitle: '',
  },
  dateBooking: new Date(),
  booking: {
    id: '',
    address: '',
    suburb: '',
    city: '',
    deliveryFee: null,
    priceKm: null,
    companyName: '',
    saleType: { value: '2', label: 'Retail Cash' },
    email: '',
    contactName: '',
    contactPhone: '',
    orderNumber: '',
    invoiceNumber: '',
    onSiteName: '',
    onSitePhone: '',
    image: null,
    onSite: false,
    loadingInstruction: '',
    delayType: { value: '', label: '' },
    delay: '',
    cardNumber: '',
    selectYear: '',
    totalAmount: '',
    allProducts: [],
    deliveryInstruction: '',
    cardType: '',
    sms: false,
    distanceRoundTrip: 0,
    selectMount: '',
    productSelected: {
      quantity: 0,
      id: '',
      weight: 0,
      volume: 0,
      notes: '',
      price: 0,
      product: {
        id: 0,
        name: '',
        code: '',
        volume: '',
        weight: '',
        price: 0,
      },
    },
    isQuote: null,
    anytime: false,
    internalNotes: '',
    nonChargeable: false,
  },
  loading: false,
  error: false,
  bookingStatus: {
    status: '',
    bookingId: '',
  },
  message: '',
};

const reducer = (
  state: DashboardState = initialState,
  action: DashboardAction
): DashboardState => {
  switch (action.type) {
    //Bookings
    case actionTypes.ADD_BOOKING:
      return {
        ...state,
        booking: {
          ...state.booking,
          [action.id]: action.payload,
        },
      };
    case actionTypes.DELETE_BOOKING:
      return {
        ...state,
        booking: {
          id: '',
          address: '',
          suburb: '',
          city: '',
          deliveryFee: null,
          priceKm: null,
          companyName: '',
          saleType: { label: '', value: '' },
          email: '',
          contactName: '',
          contactPhone: '',
          orderNumber: '',
          invoiceNumber: '',
          onSiteName: '',
          onSitePhone: '',
          image: '',
          onSite: false,
          loadingInstruction: '',
          delayType: { value: '', label: '' },
          delay: '',
          cardNumber: '',
          selectYear: '',
          totalAmount: '',
          allProducts: [],
          deliveryInstruction: '',
          latitude: '',
          longitude: '',
          sms: false,
          distanceRoundTrip: 0,
          cardType: '',
          productSelected: {
            quantity: 0,
            id: '',
            weight: 0,
            volume: 0,
            notes: '',
            price: 0,
            product: {
              id: 0,
              name: '',
              code: '',
              volume: '',
              weight: '',
              price: 0,
            },
          },
          selectMount: '',
          isQuote: null,
          anytime: false,
          internalNotes: '',
          nonChargeable: false,
        },
      };
    case actionTypes.ACTION_BOOKING:
      return {
        ...state,
        bookingStatus: {
          ...state.bookingStatus,
          status: action.payload,
        },
      };
    case actionTypes.ACTION_BOOKING_ID:
      return {
        ...state,
        bookingStatus: {
          ...state.bookingStatus,
          bookingId: action.payload,
        },
      };

    // Application
    case actionTypes.ADD_BRANCH:
      return {
        ...state,
        selectedBranch: action.payload,
      };
    case actionTypes.ALERT:
      return {
        ...state,
        alert: {
          title: action.payload.title,
          subTitle: action.payload.subTitle,
          type: action.payload.type,
        },
      };
    case actionTypes.LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case actionTypes.ADD_DATE:
      return {
        ...state,
        dateBooking: action.payload,
      };

    case actionTypes.SET_ALL_PRODUCTS:
      return {
        ...state,
        booking: {
          ...state.booking,
          allProducts: action.payload,
        },
      };
  }

  return state;
};

export interface RootReducerState {
  dashboard: DashboardState;
  quotes: QuoteReducerState;
  todos: TodosReducerState;
  bookings: BookingsReducerState;
  vehicles: VehiclesReducerState;
  products: ProductReducerState;
}
export const rootReducer = combineReducers({
  dashboard: reducer,
  quotes: quotesReducer,
  todos: todosReducer,
  bookings: bookingsReducer,
  vehicles: vehiclesReducer,
  products: productsReducer,
});
export default rootReducer;
